import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'fsthp-app',
    loadComponent: () =>
      import('./pages/fh0010/fh0010.component').then(m => m.Fh0010Component),
    title: 'ポートフォリオ検討ナビ｜第一生命保険株式会社',
  },
  {
    path: 'fsthp-app/error',
    loadComponent: () =>
      import('./pages/fh9010/fh9010.component').then(m => m.Fh9010Component),
    title: 'エラー｜ポートフォリオ検討ナビ｜第一生命保険株式会社',
  },
  {
    path: 'fsthp-app/point-attention',
    loadComponent: () =>
      import('./pages/fh0011/fh0011.component').then(m => m.Fh0011Component),
    title: 'ご留意事項｜ポートフォリオ検討ナビ｜第一生命保険株式会社',
  },
  {
    path: 'fsthp-app/risk-test',
    loadComponent: () =>
      import('./pages/fh0020/fh0020.component').then(m => m.Fh0020Component),
    title: '投資スタイル診断｜ポートフォリオ検討ナビ｜第一生命保険株式会社',
  },
  {
    path: 'fsthp-app/risk-result',
    loadComponent: () =>
      import('./pages/fh0021/fh0021.component').then(m => m.Fh0021Component),
    title: '投資スタイル診断結果｜ポートフォリオ検討ナビ｜第一生命保険株式会社',
  },
  {
    path: 'fsthp-app/choice-portfolio',
    loadComponent: () =>
      import('./pages/fh0030/fh0030.component').then(m => m.Fh0030Component),
    title: 'ポートフォリオの設定｜ポートフォリオ検討ナビ｜第一生命保険株式会社',
  },
  {
    path: 'fsthp-app/simulation',
    loadComponent: () =>
      import('./pages/fh0060/fh0060.component').then(m => m.Fh0060Component),
    title: '将来シミュレーション｜ポートフォリオ検討ナビ｜第一生命保険株式会社',
  },
];
